/**
 * KAN-751: старый единый текст инструкций (user_prompt), только для чтения.
 *
 * Показывается, пока user_prompt не пуст. Свёрнут по умолчанию. Подпись
 * говорит, работает ли бот по нему сейчас (части пусты) или уже по частям.
 */
import { useState } from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';

export const LEGACY_IN_USE_TEXT = 'Используется сейчас';
export const LEGACY_UNUSED_TEXT = 'Не используется: бот работает по частям';

interface LegacyPromptBlockProps {
  text: string;
  /** true, если части пусты и бот работает по старому тексту. */
  inUse: boolean;
  onMoveToExtra: () => void;
}

export function LegacyPromptBlock({ text, inUse, onMoveToExtra }: LegacyPromptBlockProps): JSX.Element {
  const [open, setOpen] = useState(false);
  const Icon = open ? ChevronDown : ChevronRight;

  return (
    <div
      data-testid="legacy-prompt"
      className={
        inUse
          ? 'space-y-2 rounded-md border border-amber-200 bg-amber-50 p-3'
          : 'space-y-2 rounded-md border border-border bg-gray-50 p-3'
      }>
      <button
        type="button"
        data-testid="legacy-prompt-toggle"
        aria-expanded={open}
        aria-controls="legacy-user-prompt"
        onClick={() => setOpen(o => !o)}
        className="flex w-full items-center gap-1 text-left text-sm font-medium">
        <Icon className="h-4 w-4" aria-hidden="true" />
        Инструкции (старый формат)
      </button>
      <p data-testid="legacy-prompt-status" className="text-xs text-muted-foreground">
        {inUse ? LEGACY_IN_USE_TEXT : LEGACY_UNUSED_TEXT}
      </p>
      {open && (
        <>
          <Textarea
            id="legacy-user-prompt"
            data-testid="legacy-prompt-text"
            aria-label="Инструкции (старый формат)"
            value={text}
            readOnly
            rows={4}
            className="bg-white"
          />
          {inUse && (
            <>
              <p className="text-xs text-muted-foreground">
                Будет заменено частями после заполнения.
              </p>
              <Button
                type="button"
                variant="outline"
                size="sm"
                data-testid="legacy-move-to-extra"
                onClick={onMoveToExtra}>
                Перенести в Дополнительно
              </Button>
            </>
          )}
        </>
      )}
    </div>
  );
}
